import { Icon } from "@iconify/react";
import React, { useEffect, useRef, useState } from "react";
import DashboardMain from "./DashboardRightComponents/DashboardMain/DashboardMain";
import "./Dashboard.scss";
import userImg from "../assets/images/DashboardImages/icons/userFav.png";
import logout from "../assets/icons/logouticon.svg";
import Ranking from "./DashboardRightComponents/Ranking/Ranking";
import navLogo from "../assets/icons/logo.svg";
import userImgNav from "../assets/images/young-bearded-man-with-striped-shirt 1.png";
import BrandComparison from "./DashboardRightComponents/BrandComparison/BrandComparison";
import Setting from "./DashboardRightComponents/Setting/Setting";
import { Link, useNavigate } from "react-router-dom";
import Profile from "./DashboardRightComponents/Profile/Profile";
import AnalyzeBrands from "./DashboardRightComponents/AnalyzeBrands/AnalyzeBrands";
import History from "./DashboardRightComponents/History/History";
import Analyze from "./DashboardRightComponents/analyzebrand/analyze";
import Review from "./DashboardRightComponents/Review/Review";
import ProductReview from "./DashboardRightComponents/ProductReview/ProductReview";
import { signOut } from "firebase/auth";
import { auth } from "../config";

const Dashboard = () => {
  // const [checkDashTab, setCheckDashTab] = useState("dashboardMain");
  // console.log(checkDashTab);

  const [fullWidth, setFullWidth] = useState(true);
  console.log("kk", fullWidth);
  const [activeTab, setActiveTab] = useState("dashboardMain");
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  ////////////////////////////////////////////////
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    // setShowPersonalInfo(false);
  };
  const handlechilddropdownClick = (selectedOption) => {
    setIsOpen(false);
  };
  ////////////////////////////////////////////////
  //////////////SideBarOpen//////////////////////
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebarLeft = (event) => {
    event.stopPropagation();
    setIsSidebarOpen((prev) => !prev);
  };
  /* SideBar Closed Click start */
  const dropdownRefSideBar = useRef(null);
  const handleClickOutsideBar = (event) => {
    if (
      dropdownRefSideBar.current &&
      !dropdownRefSideBar.current.contains(event.target)
    ) {
      setIsSidebarOpen(false);
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    document.addEventListener("click", handleClickOutsideBar);
    return () => {
      document.removeEventListener("click", handleClickOutsideBar);
    };
  }, []);
  /* SideBar Closed Click End */
  //////////////SideBarOpen//////////////////////

  return (
    <section className="dashboard">
      {activeTab !== "dashboardMain" && (
        <div
          className={`dashboard-left-content sidebar ${isSidebarOpen ? "open" : ""
            }`}
          ref={dropdownRefSideBar}
        >
          <div>
            <div className="dashboard-userImg-box">
              <span>
                <img src={userImg} alt="" />
              </span>
              <h5>Jack Adoms</h5>
            </div>
            <ul>
              <div
                className={`dashboardLink ${activeTab === "dashboardMain" ? "active" : ""
                  }`}
                onClick={() => {
                  handleTabChange("dashboardMain");
                  setFullWidth(true);
                }}
              >
                <Icon
                  className="iconsdash"
                  icon="radix-icons:dashboard"
                  color="#000"
                  width="25"
                  height="25"
                />
                <li>Dashboard</li>
              </div>

              {/* <Link to="/analyze"> */}
              <div
                className={`dashboardLink ${activeTab === "analyzebrand" ? "active" : ""
                  }`}
                onClick={() => {
                  handleTabChange("analyzebrand");
                }}
              >
                <svg
                  className="iconsdash"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <g clip-path="url(#clip0_3423_1362)">
                    <path
                      d="M15.125 22H1.375C0.615662 22 0 21.3843 0 20.625V4.125C0 4.00348 0.0483398 3.88683 0.134277 3.80089L3.80089 0.134277C3.88683 0.0483398 4.00348 0 4.125 0H15.125C15.8843 0 16.5 0.615662 16.5 1.375V2.29161H15.5834V1.375C15.5834 1.12189 15.3781 0.916611 15.125 0.916611H4.31467L0.916611 4.31467V20.625C0.916611 20.8781 1.12189 21.0834 1.375 21.0834H15.125C15.3781 21.0834 15.5834 20.8781 15.5834 20.625V19.7084H16.5V20.625C16.5 21.3843 15.8843 22 15.125 22Z"
                      fill="black"
                    />
                    <path
                      d="M4.12462 4.58337H0.458008V3.6666H3.66623V0.458374H4.58301V4.12498C4.58301 4.3781 4.37773 4.58337 4.12462 4.58337Z"
                      fill="black"
                    />
                    <path
                      d="M16.958 15.125H11.458C10.6985 15.125 10.083 14.5093 10.083 13.75V8.25C10.083 7.49066 10.6985 6.875 11.458 6.875H16.958C17.7173 6.875 18.333 7.49066 18.333 8.25V13.75C18.333 14.5093 17.7173 15.125 16.958 15.125ZM11.458 7.79161C11.2049 7.79161 10.9996 7.99689 10.9996 8.25V13.75C10.9996 14.0031 11.2049 14.2084 11.458 14.2084H16.958C17.2111 14.2084 17.4162 14.0031 17.4162 13.75V8.25C17.4162 7.99689 17.2111 7.79161 16.958 7.79161H11.458Z"
                      fill="black"
                    />
                    <path
                      d="M10.542 12.375H14.667V13.2916H10.542V12.375Z"
                      fill="black"
                    />
                    <path
                      d="M12.375 5.95837C11.6157 5.95837 11 5.34271 11 4.58337C11 3.82387 11.6157 3.20837 12.375 3.20837C13.1343 3.20837 13.75 3.82387 13.75 4.58337C13.75 5.34271 13.1343 5.95837 12.375 5.95837ZM12.375 4.12498C12.1219 4.12498 11.9166 4.33026 11.9166 4.58337C11.9166 4.83649 12.1219 5.0416 12.375 5.0416C12.6281 5.0416 12.8334 4.83649 12.8334 4.58337C12.8334 4.33026 12.6281 4.12498 12.375 4.12498Z"
                      fill="black"
                    />
                    <path
                      d="M11.917 5.5H12.8338V7.33339H11.917V5.5Z"
                      fill="black"
                    />
                    <path
                      d="M16.042 5.95837C15.2827 5.95837 14.667 5.34271 14.667 4.58337C14.667 3.82387 15.2827 3.20837 16.042 3.20837C16.8015 3.20837 17.417 3.82387 17.417 4.58337C17.417 5.34271 16.8015 5.95837 16.042 5.95837ZM16.042 4.12498C15.7889 4.12498 15.5838 4.33026 15.5838 4.58337C15.5838 4.83649 15.7889 5.0416 16.042 5.0416C16.2951 5.0416 16.5004 4.83649 16.5004 4.58337C16.5004 4.33026 16.2951 4.12498 16.042 4.12498Z"
                      fill="black"
                    />
                    <path
                      d="M15.583 5.5H16.4996V7.33339H15.583V5.5Z"
                      fill="black"
                    />
                    <path
                      d="M16.042 18.7916C15.2827 18.7916 14.667 18.1761 14.667 17.4166C14.667 16.6573 15.2827 16.0416 16.042 16.0416C16.8015 16.0416 17.417 16.6573 17.417 17.4166C17.417 18.1761 16.8015 18.7916 16.042 18.7916ZM16.042 16.9584C15.7889 16.9584 15.5838 17.1635 15.5838 17.4166C15.5838 17.6697 15.7889 17.875 16.042 17.875C16.2951 17.875 16.5004 17.6697 16.5004 17.4166C16.5004 17.1635 16.2951 16.9584 16.042 16.9584Z"
                      fill="black"
                    />
                    <path
                      d="M15.583 14.6666H16.4996V16.5H15.583V14.6666Z"
                      fill="black"
                    />
                    <path
                      d="M12.375 18.7916C11.6157 18.7916 11 18.1761 11 17.4166C11 16.6573 11.6157 16.0416 12.375 16.0416C13.1343 16.0416 13.75 16.6573 13.75 17.4166C13.75 18.1761 13.1343 18.7916 12.375 18.7916ZM12.375 16.9584C12.1219 16.9584 11.9166 17.1635 11.9166 17.4166C11.9166 17.6697 12.1219 17.875 12.375 17.875C12.6281 17.875 12.8334 17.6697 12.8334 17.4166C12.8334 17.1635 12.6281 16.9584 12.375 16.9584Z"
                      fill="black"
                    />
                    <path
                      d="M11.917 14.6666H12.8338V16.5H11.917V14.6666Z"
                      fill="black"
                    />
                    <path
                      d="M20.625 10.5416C19.8657 10.5416 19.25 9.9261 19.25 9.1666C19.25 8.40726 19.8657 7.7916 20.625 7.7916C21.3843 7.7916 22 8.40726 22 9.1666C22 9.9261 21.3843 10.5416 20.625 10.5416ZM20.625 8.70837C20.3719 8.70837 20.1666 8.91348 20.1666 9.1666C20.1666 9.41971 20.3719 9.62498 20.625 9.62498C20.8781 9.62498 21.0834 9.41971 21.0834 9.1666C21.0834 8.91348 20.8781 8.70837 20.625 8.70837Z"
                      fill="black"
                    />
                    <path
                      d="M17.875 8.70837H19.7084V9.62498H17.875V8.70837Z"
                      fill="black"
                    />
                    <path
                      d="M20.625 14.2084C19.8657 14.2084 19.25 13.5927 19.25 12.8334C19.25 12.0739 19.8657 11.4584 20.625 11.4584C21.3843 11.4584 22 12.0739 22 12.8334C22 13.5927 21.3843 14.2084 20.625 14.2084ZM20.625 12.375C20.3719 12.375 20.1666 12.5803 20.1666 12.8334C20.1666 13.0865 20.3719 13.2916 20.625 13.2916C20.8781 13.2916 21.0834 13.0865 21.0834 12.8334C21.0834 12.5803 20.8781 12.375 20.625 12.375Z"
                      fill="black"
                    />
                    <path
                      d="M17.875 12.375H19.7084V13.2916H17.875V12.375Z"
                      fill="black"
                    />
                    <path
                      d="M7.79199 14.2084C7.03265 14.2084 6.41699 13.5927 6.41699 12.8334C6.41699 12.0739 7.03265 11.4584 7.79199 11.4584C8.5515 11.4584 9.16699 12.0739 9.16699 12.8334C9.16699 13.5927 8.5515 14.2084 7.79199 14.2084ZM7.79199 12.375C7.53888 12.375 7.33377 12.5803 7.33377 12.8334C7.33377 13.0865 7.53888 13.2916 7.79199 13.2916C8.0451 13.2916 8.25038 13.0865 8.25038 12.8334C8.25038 12.5803 8.0451 12.375 7.79199 12.375Z"
                      fill="black"
                    />
                    <path
                      d="M8.70801 12.375H10.5412V13.2916H8.70801V12.375Z"
                      fill="black"
                    />
                    <path
                      d="M7.79199 10.5416C7.03265 10.5416 6.41699 9.9261 6.41699 9.1666C6.41699 8.40726 7.03265 7.7916 7.79199 7.7916C8.5515 7.7916 9.16699 8.40726 9.16699 9.1666C9.16699 9.9261 8.5515 10.5416 7.79199 10.5416ZM7.79199 8.70837C7.53888 8.70837 7.33377 8.91348 7.33377 9.1666C7.33377 9.41971 7.53888 9.62498 7.79199 9.62498C8.0451 9.62498 8.25038 9.41971 8.25038 9.1666C8.25038 8.91348 8.0451 8.70837 7.79199 8.70837Z"
                      fill="black"
                    />
                    <path
                      d="M8.70801 8.70837H10.5412V9.62498H8.70801V8.70837Z"
                      fill="black"
                    />
                    <path
                      d="M15.583 12.375H16.4996V13.2916H15.583V12.375Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3423_1362">
                      <rect width="22" height="22" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <li>Brand Analysis</li>
              </div>
              {/* </Link> */}

              <div
                className={`dashboardLink ${activeTab === "product" ? "active" : ""
                  }`}
                onClick={() => {
                  handleTabChange("product");
                }}
              >
                <Icon
                  icon="icon-park:ad-product"
                  color="#000"
                  className="iconsdash"
                  width="25"
                  height="25"
                />
                <li>Product Analysis</li>
              </div>

              <div
                className={`dashboardLink ${activeTab === "brandcomparison" ? "active" : ""
                  }`}
                onClick={() => {
                  handleTabChange("brandcomparison");
                }}
              >
                <Icon
                  icon="material-symbols:compare"
                  className="iconsdash"
                  color="#000"
                  width="25"
                  height="25"
                />
                <li>Brand Comparison</li>
              </div>
              <div
                className={`dashboardLink ${activeTab === "review" ? "active" : ""
                  }`}
                onClick={() => {
                  handleTabChange("review");
                }}
              >
                <Icon
                  icon="material-symbols:compare"
                  className="iconsdash"
                  color="#000"
                  width="25"
                  height="25"
                />
                <li>Brand Reviews</li>
              </div>
              <div
                className={`dashboardLink ${activeTab === "profile" ? "active" : ""
                  }`}
                onClick={() => {
                  handleTabChange("profile");
                }}
              >
                <Icon
                  className="iconsdash"
                  icon="mdi:user-outline"
                  color="#000"
                  width="29"
                  height="29"
                />
                <li>Profile</li>
              </div>

              <div
                className={`dashboardLink ${activeTab === "historyreports" ? "active" : ""
                  }`}
                onClick={() => {
                  handleTabChange("historyreports");
                }}
              >
                <Icon
                  className="iconsdash"
                  icon="octicon:history-16"
                  color="#000"
                  width="25"
                  height="25"
                />
                <li>History Reports</li>
              </div>

              <div
                className={`dashboardLink ${activeTab === "ranking" ? "active" : ""
                  }`}
                onClick={() => {
                  handleTabChange("ranking");
                }}
              >
                <Icon
                  className="iconsdash"
                  icon="solar:ranking-outline"
                  color="#000"
                  width="25"
                  height="25"
                />
                <li>Ranking</li>
              </div>

              <div
                className={`dashboardLink ${activeTab === "setting" ? "active" : ""
                  }`}
                onClick={() => {
                  handleTabChange("setting");
                }}
              >
                <Icon
                  className="iconsdash"
                  icon="tdesign:setting-1"
                  color="#000"
                  width="25"
                  height="25"
                />
                <li>Settings</li>
              </div>
            </ul>
          </div>
          <div onClick={() => {

            signOut(auth)
              .then(() => {
                // console.log("User signed out successfully.");
                navigate("/login");
              })
              .catch((error) => {
                // console.log("Error signing out:", error);
              });

          }}>
            <div className="logout">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M14 8V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H12C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V16"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 12H21M21 12L18 9M21 12L18 15"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p>Logout</p>
            </div>
          </div>
        </div>
      )}
      <div
        className={`dashboard-right-content ${fullWidth
          ? "dashboard-right-content-full-width"
          : !isSidebarOpen
            ? "open"
            : ""
          }`}
      >
        {/* navbar */}
        <nav>
          <div className="nav-logo">
            <img src={navLogo} alt="" />
            <h2>Relative Excess Differentiation</h2>
          </div>
          <div className="nav-right-content">
            <div className="profileSection" ref={dropdownRef}>
              <div className="notification-number-div">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={toggleDropdown}
                  className="svg-notification"
                  width="23"
                  height="33"
                  viewBox="0 0 23 33"
                  fill="none"
                >
                  <path
                    d="M0 27.9544V24.9749H2.58784V13.4686C2.58784 11.1848 3.1585 9.12436 4.29981 7.28736C5.44113 5.45039 6.98063 4.27189 8.91831 3.75186V3.06732C8.91831 2.35481 9.14108 1.73248 9.58662 1.20032C10.0322 0.668163 10.5732 0.402084 11.2097 0.402084C11.8462 0.402084 12.387 0.668163 12.8322 1.20032C13.2774 1.73248 13.5 2.35481 13.5 3.06732V3.75186C15.4323 4.25961 16.9774 5.43082 18.1351 7.26551C19.2928 9.10019 19.8716 11.1679 19.8716 13.4686V24.9749H22.4595V27.9544H0ZM11.2119 32.829C10.4177 32.829 9.74094 32.5027 9.18149 31.85C8.62207 31.1972 8.34236 30.4126 8.34236 29.496H14.0839C14.0839 30.4272 13.802 31.2155 13.2384 31.8609C12.6747 32.5063 11.9992 32.829 11.2119 32.829ZM5.15763 24.9749H17.2939V13.4725C17.2939 11.5294 16.6986 9.87203 15.5081 8.50046C14.3176 7.12886 12.8837 6.44307 11.2065 6.44307C9.52927 6.44307 8.10183 7.12922 6.92415 8.50154C5.74647 9.87385 5.15763 11.5295 5.15763 13.4686V24.9749Z"
                    fill="white"
                  />
                </svg>
                <span>4</span>
              </div>
              {isOpen && (
                <div className="dropdownContent">
                  <div
                    className="topSection"
                    onClick={handlechilddropdownClick}
                  >
                    <div className="Notification-head">Notification</div>
                    <ul>
                      <li>
                        <div className="note-txt-div">
                          <p>The file was deleted.</p>
                          <span>6 mins ago</span>
                        </div>
                        <Icon
                          icon="tdesign:delete-1"
                          className="notificationDell-icon"
                        />
                      </li>
                      <li>
                        <div className="note-txt-div">
                          <p>The file was deleted.</p>
                          <span>6 mins ago</span>
                        </div>
                        <Icon
                          icon="tdesign:delete-1"
                          className="notificationDell-icon"
                        />
                      </li>
                      <li>
                        <div className="note-txt-div">
                          <p>The file was deleted.</p>
                          <span>6 mins ago</span>
                        </div>
                        <Icon
                          icon="tdesign:delete-1"
                          className="notificationDell-icon"
                        />
                      </li>
                      <li>
                        <div className="note-txt-div">
                          <p>The file was deleted.</p>
                          <span>6 mins ago</span>
                        </div>
                        <Icon
                          icon="tdesign:delete-1"
                          className="notificationDell-icon"
                        />
                      </li>
                      <li>
                        <div className="note-txt-div">
                          <p>The file was deleted.</p>
                          <span>6 mins ago</span>
                        </div>
                        <Icon
                          icon="tdesign:delete-1"
                          className="notificationDell-icon"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            <div className="navUser-Icon-box">
              <img src={userImgNav} alt="" />
            </div>
            <Icon
              icon="iconamoon:menu-burger-horizontal"
              color="#fff"
              className="burger-Icon"
              onClick={(event) => toggleSidebarLeft(event)}
            />
          </div>
        </nav>
        {/* navbar */}
        {activeTab === "dashboardMain" && (
          <DashboardMain
            setActiveTab={setActiveTab}
            setFullWidth={setFullWidth}
          />
        )}
        {activeTab === "ranking" && <Ranking />}
        {activeTab === "review" && <Review />}
        {activeTab === "product" && <ProductReview />}

        {activeTab === "brandcomparison" && <BrandComparison />}
        {activeTab === "setting" && <Setting />}
        {activeTab === "profile" && <Profile />}
        {activeTab === "analyzebrand" && <AnalyzeBrands />}
        {activeTab === "historyreports" && <History />}
        {/* {activeTab === "historyreports" && <Analyze />} */}
      </div>
    </section>
  );
};

export default Dashboard;
